import React from 'react'
import { Badge } from 'primereact/badge'

const BadgeBodyTemplate = ({ rowData, field }) => {
    const value = rowData[field]

    if (!value || (Array.isArray(value) && value.length === 0)) {
        return null
    }

    // Handle comma-separated string
    const items = Array.isArray(value)
        ? value
        : value.split(',').map(s => s.trim()).filter(s => s)

    if (items.length === 0) {
        return null
    }

    return (
        <div className="d-flex flex-wrap">
            {items.map((item, index) => (
                <Badge key={index} value={item} severity="success" className="me-1" />
            ))}
        </div>
    )
}

export default BadgeBodyTemplate
